import SeoHead from './SeoHead';

export { SeoHead };
